module.exports = __webpack_public_path__ + "img/top1.6f99f70a.png";